module.exports = __webpack_public_path__ + "static/media/DLF - Gradiente Logo Azul Escuro.7f8aefde.svg";